import React from 'react'

import PropTypes from 'prop-types'

import './chapters.css'

const Chapters = (props) => {
  return (
    <div className={`chapters-thq-chapters-elm ${props.rootClassName} `}>
      <div className="chapters-thq-default-elm">
        <div className="chapters-thq-content-elm1">
          <img
            alt="image"
            src={props.imageDefault1}
            className="chapters-image1"
          />
          <div className="chapters-thq-text-elm1">
            <div className="chapters-container1">
              <span className="chapters-text1">{props.chapterDefault1}</span>
              <div className="chapters-thq-divider-elm1"></div>
              <span className="chapters-text2">{props.indexDefault1}</span>
            </div>
            <span className="chapters-text3">{props.nameDefault1}</span>
          </div>
        </div>
        <div className="chapters-thq-width-elm1"></div>
        <div className="chapters-thq-height-elm1"></div>
      </div>
      <div className="chapters-thq-active-elm">
        <div className="chapters-thq-content-elm2">
          <img
            alt="image"
            src={props.imageActive1}
            className="chapters-image2"
          />
          <div className="chapters-thq-text-elm2">
            <div className="chapters-container2">
              <span className="chapters-text4">{props.chapterActive1}</span>
              <div className="chapters-thq-divider-elm2"></div>
              <span className="chapters-text5">{props.indexActive1}</span>
            </div>
            <span className="chapters-text6">{props.nameActive1}</span>
          </div>
        </div>
        <div className="chapters-thq-width-elm2"></div>
        <div className="chapters-thq-height-elm2"></div>
      </div>
    </div>
  )
}

Chapters.defaultProps = {
  imageDefault1: '/nav patterns/test.svg',
  imageActive1: '/nav patterns/test.svg',
  indexDefault1: '08',
  chapterActive1: 'Chapter 01',
  chapterDefault1: 'Chapter 01',
  indexActive1: '08',
  nameDefault1: 'Ambassador Program',
  nameActive1: 'Ambassador Program',
  rootClassName: '',
}

Chapters.propTypes = {
  imageDefault1: PropTypes.string,
  imageActive1: PropTypes.string,
  indexDefault1: PropTypes.string,
  chapterActive1: PropTypes.string,
  chapterDefault1: PropTypes.string,
  indexActive1: PropTypes.string,
  nameDefault1: PropTypes.string,
  nameActive1: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Chapters
